(function () {
  const LAPTOP_KG = 331;
  const DESKTOP_KG = 450;
  const PHONE_KG = 50;
  const MONITOR_PERIPH_KG = 150;
  const MEETINGROOM_KG = 500;
  const AI_USER_KG = 150;
  const ZOOM_USER_KG = 100;

  const CLOUD_KG_LIFETIME_PER_USER = 1200;
  const M2_PER_PERSON = 12;
  const OFFICE_ELEC_KWH_M2_YR = 180;
  const STATE_GRID_KG_PER_KWH = 0.77;

  const PACKAGING_FACTOR = 0.02;
  const OFFSET_PRICE_PER_TONNE = 35.0;
  const COMPANY_VEHICLE_KG_PER_KM = 0.22;
  const OFFICE_POWER_KG_PER_YEAR = M2_PER_PERSON * OFFICE_ELEC_KWH_M2_YR * STATE_GRID_KG_PER_KWH;

  function initCalculator(sectionRoot) {
    if (!sectionRoot || sectionRoot.dataset.tgfCalculatorReady === 'true') return;

    sectionRoot.dataset.tgfCalculatorReady = 'true';

    const modalId = sectionRoot.dataset.modalId;
    const hubspotPortalId = sectionRoot.dataset.hubspotPortalId || '';
    const hubspotFormId = sectionRoot.dataset.hubspotFormGuid || '';

    const modal = document.getElementById(modalId);
    if (!modal) return;

    if (!modal.dataset.movedToBody) {
      document.body.appendChild(modal);
      modal.dataset.movedToBody = 'true';
    }

    const q = (selector, root = document) => (root ? root.querySelector(selector) : null);
    const qa = (selector, root = document) => (root ? Array.from(root.querySelectorAll(selector)) : []);
    const clamp0 = value => Math.max(0, Number(value || 0));

    const money = value => Number(value || 0).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });

    const form = q('#tgfCalcForm', sectionRoot);
    const btnCalc = q('#tgfCalcBtn', sectionRoot);
    const btnCloseEls = qa('[data-close-modal]', modal);
    const modalSteps = qa('.tgf-modal-step', modal);
    const btnNext = q('#tgfNextBtn', modal);
    const btnBack = q('#tgfBackBtn', modal);
    const btnDetails = q('#tgfToggleDetails', modal);
    const detailsPanel = q('#tgfDetailsPanel', modal);
    const resultSummary = q('#tgfResultSummary', modal);
    const elTonnes = q('#tgfTonnes', modal);
    const elCost = q('#tgfCost', modal);
    const dialog = q('.tgf-modal__dialog', modal);

    function setModalStep(stepName) {
      modalSteps.forEach(step => {
        step.classList.toggle('is-active', step.dataset.step === stepName);
      });
    }

    function openModal() {
      modal.hidden = false;
      setModalStep('results');
      document.body.classList.add('tgf-modal-open');
      document.documentElement.classList.add('tgf-modal-open');
      document.addEventListener('keydown', escClose);
      if (dialog) dialog.focus();
    }

    function closeModal() {
      modal.hidden = true;
      setModalStep('results');
      document.body.classList.remove('tgf-modal-open');
      document.documentElement.classList.remove('tgf-modal-open');
      document.removeEventListener('keydown', escClose);
    }

    function escClose(event) {
      if (event.key === 'Escape') closeModal();
    }

    btnCloseEls.forEach(button => button.addEventListener('click', closeModal));

    modal.addEventListener('click', event => {
      if (event.target.closest('[data-close-modal]')) closeModal();
    });

    function validateNumberInput(input) {
      const value = (input.value || '').trim();
      const isValid = value === '' || (/^\d+$/.test(value) && Number(value) >= 0);
      const errEl = q(`.tgf-error[data-for="${input.id}"]`, sectionRoot);

      input.classList.toggle('tgf-invalid', !isValid);

      if (errEl) {
        errEl.textContent = isValid ? '' : 'Enter a non-negative number.';
      }

      return isValid;
    }

    qa('#tgfCalcForm input[type="number"]', sectionRoot).forEach(input => {
      input.addEventListener('input', () => validateNumberInput(input));
    });

    function gateCalc() {
      if (!form || !btnCalc) return;

      const numInputs = Array.from(form.querySelectorAll('input[type="number"]'));
      const empInp = q('#tgfEmployees', sectionRoot);

      function isValidNumberInput(input) {
        const value = (input.value || '').trim();
        return value === '' || (/^\d+$/.test(value) && Number(value) >= 0);
      }

      function checkReady() {
        const allOk = numInputs.every(isValidNumberInput);
        const empPositive = empInp ? Number(empInp.value) > 0 : false;
        const enable = allOk && empPositive;

        btnCalc.disabled = !enable;
        btnCalc.setAttribute('aria-disabled', String(!enable));
      }

      numInputs.forEach(input => input.addEventListener('input', checkReady));
      checkReady();
    }

    function calc(inputs) {
      const employees = clamp0(inputs.employees);
      const officePct = Math.min(100, Math.max(0, Number(inputs.office_pct || 0)));

      const laptopsKg = clamp0(inputs.laptops) * LAPTOP_KG;
      const desktopsKg = clamp0(inputs.desktops) * DESKTOP_KG;
      const mobilesKg = clamp0(inputs.mobiles) * PHONE_KG;
      const monitorsKg = clamp0(inputs.monitors) * MONITOR_PERIPH_KG;
      const avRoomsKg = clamp0(inputs.avRooms) * MEETINGROOM_KG;

      const aiUsersKg = employees * AI_USER_KG;
      const zoomUsersKg = employees * ZOOM_USER_KG;

      const deviceRawKg = laptopsKg + desktopsKg + mobilesKg + monitorsKg + avRoomsKg + aiUsersKg + zoomUsersKg;
      const deviceKg = deviceRawKg * (1 + PACKAGING_FACTOR);

      const inOffice = employees * (officePct / 100);
      const cloudKgLifetime = inOffice * CLOUD_KG_LIFETIME_PER_USER;

      const totalKg = deviceKg + cloudKgLifetime;
      const totalTonnes = +(totalKg / 1000).toFixed(2);
      const offsetCost = +(totalTonnes * OFFSET_PRICE_PER_TONNE).toFixed(2);

      const companyVehicleKm = (totalTonnes * 1000) / COMPANY_VEHICLE_KG_PER_KM;
      const peoplePoweredYear = totalKg / OFFICE_POWER_KG_PER_YEAR;
      const laptopsNeutralised = Math.round(totalKg / (LAPTOP_KG * (1 + PACKAGING_FACTOR)));

      const toTonnes = kg => +(kg / 1000).toFixed(2);

      const category = kg => {
        const tonnes = toTonnes(kg);
        return {
          tonnes,
          avoided: tonnes
        };
      };

      const categories = {
        laptops: category(laptopsKg * (1 + PACKAGING_FACTOR)),
        mobiles: category(mobilesKg * (1 + PACKAGING_FACTOR)),
        monitors: category(monitorsKg * (1 + PACKAGING_FACTOR)),
        cloud: category(cloudKgLifetime),
        datacentres: category(0),
        offices: category(0),
        av: category(avRoomsKg * (1 + PACKAGING_FACTOR)),
        ai: category(aiUsersKg * (1 + PACKAGING_FACTOR)),
        zoom: category(zoomUsersKg * (1 + PACKAGING_FACTOR))
      };

      const breakdownTonnes = {
        devices: +(deviceKg / 1000).toFixed(2),
        cloud: +(cloudKgLifetime / 1000).toFixed(2),
        office: 0,
        categories
      };

      return {
        totalKg,
        totalTonnes,
        offsetCost,
        breakdownTonnes,
        categories,
        scope: {
          company_vehicle_km: Math.round(companyVehicleKm),
          people_powered_year: +peoplePoweredYear.toFixed(1),
          laptops_neutralised: laptopsNeutralised
        }
      };
    }

    function setModalText(selector, value) {
      const el = q(selector, modal);
      if (el) el.textContent = value;
    }

    function setModalValue(selector, value) {
      const el = q(selector, modal);
      if (el) el.value = value ?? '';
    }

    function renderIctEnvironment(inputs) {
      const numberText = value => Number(value || 0).toLocaleString();

      setModalText('#tgfEnvEmployees', numberText(inputs.employees));
      setModalText('#tgfEnvOfficePct', `${numberText(inputs.office_pct)}%`);
      setModalText('#tgfEnvLaptops', numberText(inputs.laptops));
      setModalText('#tgfEnvMobiles', numberText(inputs.mobiles));
      setModalText('#tgfEnvMonitors', numberText(inputs.monitors));
    }

    function saveHiddenValues(res) {
      setModalValue('#tgfTotalTonnes', res.totalTonnes);
      setModalValue('#tgfOffsetCost', res.offsetCost.toFixed(2));
      setModalValue('#tgfBreakdownJson', JSON.stringify(res.breakdownTonnes));

      setModalValue('#tgfCalcLaptopsTonnes', res.categories.laptops.tonnes);
      setModalValue('#tgfCalcLaptopsAvoided', res.categories.laptops.avoided);
      setModalValue('#tgfCalcMobilesTonnes', res.categories.mobiles.tonnes);
      setModalValue('#tgfCalcMobilesAvoided', res.categories.mobiles.avoided);
      setModalValue('#tgfCalcMonitorsTonnes', res.categories.monitors.tonnes);
      setModalValue('#tgfCalcMonitorsAvoided', res.categories.monitors.avoided);
      setModalValue('#tgfCalcCloudTonnes', res.categories.cloud.tonnes);
      setModalValue('#tgfCalcCloudAvoided', res.categories.cloud.avoided);
      setModalValue('#tgfCalcDatacentresTonnes', res.categories.datacentres.tonnes);
      setModalValue('#tgfCalcDatacentresAvoided', res.categories.datacentres.avoided);
      setModalValue('#tgfCalcOfficesTonnes', res.categories.offices.tonnes);
      setModalValue('#tgfCalcOfficesAvoided', res.categories.offices.avoided);
      setModalValue('#tgfCalcAvTonnes', res.categories.av.tonnes);
      setModalValue('#tgfCalcAvAvoided', res.categories.av.avoided);
      setModalValue('#tgfCalcAiTonnes', res.categories.ai.tonnes);
      setModalValue('#tgfCalcAiAvoided', res.categories.ai.avoided);
      setModalValue('#tgfCalcZoomTonnes', res.categories.zoom.tonnes);
      setModalValue('#tgfCalcZoomAvoided', res.categories.zoom.avoided);
      setModalValue('#tgfUnitPrice', OFFSET_PRICE_PER_TONNE.toFixed(2));
    }

    function getCookie(name) {
      const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
      return match ? decodeURIComponent(match[2]) : '';
    }

    function getHubspotValues() {
      return {
        employees: q('#tgfEmployees', sectionRoot)?.value || '',
        office_pct: q('#tgfOfficePct', sectionRoot)?.value || '',
        laptops: q('#tgfLaptops', sectionRoot)?.value || '',
        desktops: q('#tgfDesktops', sectionRoot)?.value || '',
        mobiles: q('#tgfMobiles', sectionRoot)?.value || '',
        monitors: q('#tgfMonitors', sectionRoot)?.value || '',
        avrooms: q('#tgfAvRooms', sectionRoot)?.value || '',

        calculator_total_tonnes: q('#tgfTotalTonnes', modal)?.value || '',
        calculator_offset_cost_aud: q('#tgfOffsetCost', modal)?.value || '',
        calculator_breakdown_json: q('#tgfBreakdownJson', modal)?.value || '',

        calc_laptops_tonnes: q('#tgfCalcLaptopsTonnes', modal)?.value || '',
        calc_laptops_avoided: q('#tgfCalcLaptopsAvoided', modal)?.value || '',
        calc_mobiles_tonnes: q('#tgfCalcMobilesTonnes', modal)?.value || '',
        calc_mobiles_avoided: q('#tgfCalcMobilesAvoided', modal)?.value || '',
        calc_monitors_tonnes: q('#tgfCalcMonitorsTonnes', modal)?.value || '',
        calc_monitors_avoided: q('#tgfCalcMonitorsAvoided', modal)?.value || '',
        calc_cloud_tonnes: q('#tgfCalcCloudTonnes', modal)?.value || '',
        calc_cloud_avoided: q('#tgfCalcCloudAvoided', modal)?.value || '',
        calc_datacentres_tonnes: q('#tgfCalcDatacentresTonnes', modal)?.value || '',
        calc_datacentres_avoided: q('#tgfCalcDatacentresAvoided', modal)?.value || '',
        calc_offices_tonnes: q('#tgfCalcOfficesTonnes', modal)?.value || '',
        calc_offices_avoided: q('#tgfCalcOfficesAvoided', modal)?.value || '',
        calc_av_tonnes: q('#tgfCalcAvTonnes', modal)?.value || '',
        calc_av_avoided: q('#tgfCalcAvAvoided', modal)?.value || '',
        calc_ai_tonnes: q('#tgfCalcAiTonnes', modal)?.value || '',
        calc_ai_avoided: q('#tgfCalcAiAvoided', modal)?.value || '',
        calc_zoom_tonnes: q('#tgfCalcZoomTonnes', modal)?.value || '',
        calc_zoom_avoided: q('#tgfCalcZoomAvoided', modal)?.value || '',

        calculator_unit_price_aud: q('#tgfUnitPrice', modal)?.value || '35.00',
        offset_price_per_tonne: q('#tgfUnitPrice', modal)?.value || '35.00',

        scope1_company_vehicle_km: '',
        scope2_people_powered_year: '',
        scope3_laptops_neutralised: '',
        scope3_mel_bne_flights: '',
        scope3_car_commutes: '',
        scope3_train_commutes: ''
      };
    }

    function setupLeadForm() {
      const leadForm = q('#tgfLeadForm', modal);
      const state = q('#tgfSubmitState', modal);

      if (!leadForm || leadForm.dataset.ready === 'true') return;

      leadForm.dataset.ready = 'true';

      leadForm.addEventListener('submit', event => {
        event.preventDefault();

        if (typeof leadForm.reportValidity === 'function' && !leadForm.reportValidity()) return;

        const submitBtn = leadForm.querySelector('button[type="submit"], input[type="submit"]');
        const formData = new FormData(leadForm);
        const fieldMap = {};

        formData.forEach((value, name) => {
          fieldMap[name] = value;
        });

        if (!fieldMap.newsletter_opt_in) {
          fieldMap.newsletter_opt_in = 'false';
        }

        Object.entries(getHubspotValues()).forEach(([name, value]) => {
          fieldMap[name] = value;
        });

        const payload = {
          fields: Object.entries(fieldMap).map(([name, value]) => ({
            name,
            value: String(value || '')
          })),
          context: {
            hutk: getCookie('hubspotutk'),
            pageUri: window.location.href,
            pageName: document.title
          },
          skipValidation: true
        };

        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.setAttribute('aria-disabled', 'true');
        }

        if (state) state.textContent = 'Submitting...';

        fetch(`https://api.hsforms.com/submissions/v3/integration/submit/${hubspotPortalId}/${hubspotFormId}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload)
        })
          .then(async response => {
            const data = await response.json().catch(() => ({}));

            if (!response.ok) {
              console.error('HubSpot error:', data);

              if (submitBtn) {
                submitBtn.disabled = false;
                submitBtn.removeAttribute('aria-disabled');
              }

              if (state) {
                state.textContent = data.message || 'Sorry, something went wrong. Please try again.';
              }

              return;
            }

            console.log('HubSpot success:', data);

            if (state) state.textContent = 'Thanks, your emissions estimate report is on the way.';
            leadForm.style.display = 'none';
          })
          .catch(error => {
            console.error('HubSpot failed:', error);

            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.removeAttribute('aria-disabled');
            }

            if (state) state.textContent = 'Sorry, something went wrong. Please try again.';
          });
      });
    }

    function closeDetailsPanel() {
      if (!detailsPanel || !btnDetails) return;

      detailsPanel.hidden = true;

      if (resultSummary) {
        resultSummary.hidden = false;
      }

      btnDetails.textContent = 'More details ↗';
      btnDetails.setAttribute('aria-expanded', 'false');
    }

    function renderSourceBreakdown(res) {
      const devicesValue = res.breakdownTonnes.devices || 0;
      const cloudValue = res.breakdownTonnes.cloud || 0;
      const total = Math.max(res.totalTonnes || 0, 0.01);
      const percentage = value => Math.min(100, Math.max(0, (value / total) * 100));

      const setText = (selector, value) => {
        const el = q(selector, modal);
        if (el) el.textContent = Number(value || 0).toFixed(2);
      };

      const setPlainText = (selector, value) => {
        const el = q(selector, modal);
        if (el) el.textContent = value;
      };

      const setBar = (selector, value) => {
        const el = q(selector, modal);
        if (el) el.style.width = `${percentage(value)}%`;
      };

      const setDetailRow = (name, value) => {
        const pct = Math.round(percentage(value));

        setPlainText(`#tgfDetail${name}Tonnes`, `${Number(value || 0).toFixed(2)} t CO₂e`);
        setPlainText(`#tgfDetail${name}Pct`, `${pct}%`);
        setBar(`#tgfDetail${name}Bar`, value);
      };

      setText('#tgfDevicesTonnes', devicesValue);
      setText('#tgfCloudTonnes', cloudValue);

      setBar('#tgfDevicesBar', devicesValue);
      setBar('#tgfCloudBar', cloudValue);

      setDetailRow('Devices', devicesValue);
      setDetailRow('Cloud', cloudValue);

      setPlainText('#tgfDetailTotalTonnes', Number(res.totalTonnes || 0).toLocaleString());
      setPlainText('#tgfDetailOffsetCost', money(res.offsetCost));
    }

    if (btnDetails && detailsPanel) {
      btnDetails.setAttribute('aria-expanded', 'false');

      btnDetails.addEventListener('click', () => {
        const showDetails = detailsPanel.hidden;

        detailsPanel.hidden = !showDetails;

        if (resultSummary) {
          resultSummary.hidden = showDetails;
        }

        btnDetails.textContent = showDetails ? 'Hide details ↑' : 'More details ↗';
        btnDetails.setAttribute('aria-expanded', String(showDetails));
      });
    }

    if (btnCalc) {
      btnCalc.addEventListener('click', () => {
        const numInputs = qa('#tgfCalcForm input[type="number"]', sectionRoot);
        let ok = true;

        numInputs.forEach(input => {
          if (!validateNumberInput(input)) ok = false;
        });

        if (clamp0(q('#tgfEmployees', sectionRoot).value) <= 0) ok = false;
        if (!ok) return;

        const inputs = {
          employees: q('#tgfEmployees', sectionRoot).value,
          office_pct: q('#tgfOfficePct', sectionRoot).value,
          laptops: q('#tgfLaptops', sectionRoot).value,
          desktops: q('#tgfDesktops', sectionRoot).value,
          mobiles: q('#tgfMobiles', sectionRoot).value,
          monitors: q('#tgfMonitors', sectionRoot).value,
          avRooms: q('#tgfAvRooms', sectionRoot).value
        };

        const res = calc(inputs);

        if (elTonnes) elTonnes.textContent = res.totalTonnes.toLocaleString();
        if (elCost) elCost.textContent = money(res.offsetCost);

        renderIctEnvironment(inputs);
        renderSourceBreakdown(res);
        saveHiddenValues(res);
        closeDetailsPanel();
        openModal();
      });
    }

    if (btnNext) {
      btnNext.addEventListener('click', () => {
        setModalStep('form');
        setupLeadForm();
      });
    }

    if (btnBack) {
      btnBack.addEventListener('click', () => {
        setModalStep('results');
      });
    }

    gateCalc();
  }

  function initAllCalculators(scope) {
    const root = scope || document;
    const sections = root.querySelectorAll('[data-tgf-carbon-calculator]');

    sections.forEach(section => initCalculator(section));
  }

  document.addEventListener('DOMContentLoaded', () => initAllCalculators(document));

  document.addEventListener('shopify:section:load', event => {
    initAllCalculators(event.target);
  });
})();